<!--  -->
<template>
  <div class="container">
    <div class="home" v-if="type == 1">
      <div class="top-box">
        <div class="flexrbc">
          <div class="flexr0c">
            <div class="title-label"></div>
            <div class="title">预申报矿产调运</div>
          </div>
          <div class="flexr0c">
            <div v-if="preDeclare == 1" class="addOre flexrcc" @click="addPre">
              <img src="../../assets/imgs/home/add.png" alt />
              <div class="btn">新增预申报</div>
            </div>
            <div class="export" @click="exportTable">导出</div>
          </div>
        </div>
      </div>
      <div class="search-box flexr0c">
        <div class="flexr0c select-box">
          <div class="label">矿种</div>
          <Select v-model="oreId" style="width: 140px" @on-change="getTable(1)" filterable>
            <Option v-for="item in oreList" :value="item.oreId" :key="item.index">{{ item.oreName }}</Option>
          </Select>
        </div>
        <div class="flexr0c select-box">
          <div class="label">申报状态</div>
          <Select v-model="state" style="width: 140px" @on-change="getTable(1)">
            <Option v-for="item in statusList" :value="item.value" :key="item.index">{{ item.name }}</Option>
          </Select>
        </div>
        <div class="flexr0c search-item">
          <div class="label">需方企业</div>
          <Input v-model="buyerName" icon="ios-search" placeholder="" style="width: 160px" @on-click="getTable(1)" @on-enter="getTable(1)" />
        </div>
        <div class="flexr0c search-item">
          <div class="label">预申报编号</div>
          <Input v-model="contractNo" icon="ios-search" placeholder="" style="width: 160px" @on-click="getTable(1)" @on-enter="getTable(1)" />
        </div>
      </div>
      <div class="table-box">
        <div class="table">
          <Table max-height="" :loading="loading1" border stripe :columns="tableHead" :data="tableData">
            <template slot-scope="{ row }" slot="contractNo">
              <div class="order-id" @click="look(row)">
                {{ row.contractNo }}
              </div>
            </template>
            <template slot-scope="{ row }" slot="setStartDateStr">
              <div>{{ row.setStartDateStr }}~{{ row.setEndDateStr }}</div>
            </template>
            <template slot-scope="{ row, index }" slot="state">
              <div class="flexr0c ckeck-state">
                <!-- 已驳回 -->
                <div class="rejected iconfont" v-if="row.state == '2'">&#xe60d;</div>
                <!-- 未审核=审批中 -->
                <div class="iconfont" v-if="row.state == '0'">&#xe606;</div>
                <!-- 已审核 -->
                <img class="checked" v-if="row.state == '1'" src="../../assets/imgs/home/complete.png" alt="" />
                <!-- 执行中 -->
                <div class="iconfont" v-if="row.state == '3'">
                  <span>&#xe60e;</span>
                </div>
                <!-- 已结束 -->
                <div class="iconfont" v-if="row.state == '4'">&#xe60f;</div>
                <div :class="row.state == '2' ? 'rejected' : ''">
                  {{ row.status }}
                </div>
                <Poptip trigger="hover" :content="tableData[index].rejectCause" placement="right">
                  <img class="rejected-icon" v-if="row.state == '2'" src="../../assets/imgs/home/question.png" alt="" />
                </Poptip>
              </div>
            </template>
            <template slot-scope="{ row }" slot="enterpriseName">
              <div class="comName">{{ row.enterpriseName }}</div>
            </template>
            <template slot-scope="{ row }" slot="buyerName">
              <div class="comName">{{ row.buyerName }}</div>
            </template>
            <template class="flexr0c" slot-scope="{ row, index }" slot="action">
              <div class="flexr0c icon-box" @mouseenter="hover(index)">
                <!-- 执行中、已结束 -->
                <div v-show="row.state == '3' || row.state == '4'" class="flexr0c" @click="toDetail(row, index)">
                  <div class="iconfont">&#xe604;</div>
                  <div class="tips">查看</div>
                </div>
                <!-- 已驳回 -->
                <div v-show="row.state == '2'" class="flexr0c" @click="edit(row, '编辑预申报')">
                  <div class="iconfont">&#xe601;</div>
                  <div class="tips">编辑</div>
                </div>
                <div v-show="row.state == '2'" class="flexr0c" @click="del(row.id)">
                  <div class="iconfont">&#xe603;</div>
                  <div class="tips">删除</div>
                </div>
                <!-- 执行中、已审批 -->
                <div v-show="(row.state == '3' || (row.state == '1' && row.setStartDateStr<=date)) && preDeclare == 1" class="flexr0c dispatch" @click="dispatch(index)">
                  <div class="iconfont">&#xe60b;</div>
                  <div class="tips dispatch">调运</div>
                </div>
                <div v-show="row.state == '1' && row.setStartDateStr>date && preDeclare == 1" class="flexr0c disable">
                  <div class="iconfont">&#xe60b;</div>
                  <div class="tips disable">调运</div>
                </div>
                <img v-show="row.state == '1' && row.time" src="../../assets/imgs/home/question.png" alt="" @mouseenter="tips2 = true" @mouseleave="tips2 = false" />
                <div v-show="row.state == '1' && row.time && tips2" class="dialog-box flexcc0">
                  <p>说明：</p>
                  <p>未到调运时间</p>
                </div>
              </div>
            </template>
          </Table>
          <div style="margin: 10px; overflow: hidden">
            <div style="float: right">
              <Page :total="total" :page-size="pageSize" :current="1" @on-change="changePage" show-elevator show-total> </Page>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="detail" v-if="type == 2">
      <div class="top flexr0c">
        <img class="addr" src="../../assets/imgs/home/location.png" alt="" />
        <div class="title" @click="manage">预申报矿产调运</div>
        <img class="arrow" src="../../assets/imgs/home/rightarrow.png" alt="" />
        <div class="title" @click="type = 2">查看详情</div>
      </div>
      <div class="content">
        <div class="top-card flexr">
          <div class="card-left flexc0s">
            <div class="label">预申报编号</div>
            <div class="value">{{ lookInfo.contractNo }}</div>
          </div>
          <div class="card-right flexrbc">
            <div>
              <div class="flexr0c">
                <div class="label two-word"><span class="span1">矿种</span><span>：</span></div>
                <div class="value">{{ lookInfo.oreName }}</div>
              </div>
              <div class="flexr0c">
                <div class="label">需方企业：</div>
                <div class="value">{{ lookInfo.buyerName }}</div>
              </div>
              <div class="flexr0c">
                <div class="label label2">剩余执行时间：</div>
                <div class="value red">{{ lookInfo.lastTime }}</div>
              </div>
            </div>
            <img v-if="end" src="../../assets/imgs/home/end.png" alt="" />
          </div>
        </div>
        <div class="content2">
          <div class="title-box flexr0c">
            <div class="title">已扣税费(元)</div>
            <div class="title">已调运量(吨)</div>
            <div class="title">预计剩余可调税费(元)</div>
            <div class="title">预计剩余可调运量(吨)</div>
          </div>
          <div class="item-box flexr0c">
            <div class="num">{{ lookInfo.moneyWeightMap.SUM_PAY_MONEY }}</div>
            <div class="num">{{ lookInfo.moneyWeightMap.SUM_NET_WEIGHT }}</div>
            <div class="num red">
              {{ Number(lastMoney).toFixed(2) }}
            </div>
            <div class="num red">
              {{ Number(lastWeight).toFixed(2) }}
            </div>
          </div>
          <div class="table">
            <Table max-height="" :loading="loading2" border stripe :columns="tableHead2" :data="tableData2">
              <template slot-scope="{ row }" slot="notPassCount">
                <div class="red">{{ row.notPassCount }}</div>
              </template>
              <template class="flexr0c" slot-scope="{ row, index }" slot="detail">
                <div class="flexr0c look-box" @click="getDispatchDetail(row.id, index)">
                  <div class="iconfont">&#xe604;</div>
                  <div class="tips">查看</div>
                </div>
              </template>
            </Table>
          </div>
          <div class="look-more flexrcc" @click="lookMore" v-if="showMore">
            <div class="txt">查看更多</div>
            <img src="../../assets/imgs/home/look-more.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="lookBox" v-if="type == 3">
      <div class="top flexr0c">
        <img class="addr" src="../../assets/imgs/home/location.png" alt="" />
        <div class="title" @click="lookDetail">预申报矿产调运</div>
        <img class="arrow" src="../../assets/imgs/home/rightarrow.png" alt="" />
        <div class="title">查看</div>
      </div>
      <div class="lookBox_content">
        <div class="flex_between">
          <div>
            <div class="flex_between_son1">预申报编号</div>
            <div class="flex_between_son2">{{ lookInfo.contractNo }}</div>
          </div>
          <div>
            <div class="flex_between_son1">交易矿种</div>
            <div class="flex_between_son2">{{ lookInfo.oreName }}</div>
          </div>
        </div>
        <div class="flex_between">
          <div>
            <div class="flex_between_son1">合同量（吨）</div>
            <div class="flex_between_son2">{{ lookInfo.contNum }}</div>
          </div>
          <div>
            <div class="flex_between_son1">成交价（元/吨）</div>
            <div class="flex_between_son2">{{ lookInfo.orePrice }}</div>
          </div>
        </div>
        <div class="flex_between">
          <div>
            <div class="flex_between_son1">调用企业</div>
            <div class="flex_between_son2">{{ lookInfo.enterpriseName }}</div>
          </div>
          <div>
            <div class="flex_between_son1">需方企业</div>
            <div class="flex_between_son2">{{ lookInfo.buyer }}</div>
          </div>
        </div>
        <div class="flex_between">
          <div>
            <div class="flex_between_son1">装运地</div>
            <div class="flex_between_son2">{{ lookInfo.startDir }}</div>
          </div>
          <div>
            <div class="flex_between_son1">目的地</div>
            <div class="flex_between_son2">{{ lookInfo.endDir }}</div>
          </div>
        </div>
        <div class="flex_between">
          <div>
            <div class="flex_between_son1">合同执行日期</div>
            <div class="flex_between_son2">{{ lookInfo.setStartDateStr }}~{{ lookInfo.setEndDateStr }}</div>
          </div>
          <!-- <div>
            <div class="flex_between_son1">身份证号</div>
            <div class="flex_between_son2">{{lookInfo.endDir}}</div>
          </div> -->
        </div>
        <div class="flex_between">
          <div>
            <div class="flex_between_son1">质量要求</div>
            <div class="flex_between_son2" style="width: 180%">
              {{ lookInfo.qrDescribe }}
            </div>
          </div>
        </div>
        <div class="lookBox_imgBox">
          <div class="lookBox_imgBox_title">合同照片</div>
          <div class="imgArr">
            <div class="imgArr_son" v-for="item in imgArr">
              <img @click="gobig(fileCommonUrl + item)" :src="fileCommonUrl + item" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 查看大图 -->
    <vue-viewer ref="myViewer" className="my_class" :visible.sync="isShowBig" :images="bigUrl"></vue-viewer>
    <div class="dispatch-detail" v-if="type == 4">
      <div class="top flexr0c">
        <img class="addr" src="../../assets/imgs/home/location.png" alt="" />
        <div class="title" @click="manage">预申报矿产调运</div>
        <img class="arrow" src="../../assets/imgs/home/rightarrow.png" alt="" />
        <div class="title" @click="type = 2">查看详情</div>
        <img class="arrow" src="../../assets/imgs/home/rightarrow.png" alt="" />
        <div class="title">调运详情</div>
      </div>
      <div class="top-card flexr">
        <div class="card-left flexc0s">
          <div class="label">过站验证码</div>
          <div class="value">{{ dispatchDetail.checkCode }}</div>
          <div class="time">
            剩余执行时间：<span class="red">{{ dispatchDetail.remainTime }}</span>
          </div>
        </div>
        <div class="card-right flexr0c">
          <div class="flexc0s">
            <div class="label flexr0c">
              <div><span class="label-txt">矿种</span><span>：</span></div>
              <div>{{ dispatchDetail.oreName }}</div>
            </div>
            <div class="label flexr0c">
              <div>调运时间：</div>
              <div>{{ dispatchDetail.createTime }}</div>
            </div>
            <div class="label flexr0c">
              <div><span class="label-txt">有效期</span><span>：</span></div>
              <div>{{ dispatchDetail.validHours }}小时</div>
            </div>
          </div>
          <div class="flexc0s">
            <div class="label flexr0c">
              <div><span class="label-txt">装运地</span><span>：</span></div>
              <div>{{ dispatchDetail.sourceArea }}</div>
            </div>
            <div class="label flexr0c">
              <div><span class="label-txt">目的地</span><span>：</span></div>
              <div>{{ dispatchDetail.destArea }}</div>
            </div>
            <div class="label flexr0c">
              <div>需方企业：</div>
              <div>{{ dispatchDetail.buyerName }}</div>
            </div>
          </div>
          <img v-if="failure" src="../../assets/imgs/home/failure.png" alt="" />
        </div>
      </div>
      <div class="table">
        <Table max-height="" :loading="loading3" border stripe :columns="tableHead3" :data="tableData3">
          <template slot-scope="{ row }" slot="state">
            <div :class="row.state == '未过站' ? 'red' : 'green'">
              {{ row.state }}
            </div>
          </template>
        </Table>
      </div>
    </div>
    <div class="no-data" v-if="type == 5">
      <div class="top-box">
        <div class="flexrbc">
          <div class="flexr0c">
            <div class="title-label"></div>
            <div class="title">预申报矿产调运</div>
          </div>
        </div>
      </div>
      <div class="search-box flexr0c">
        <div class="flexr0c select-box">
          <div class="label">矿种</div>
          <Select v-model="oreId" style="width: 140px" @on-change="getTable(1)">
            <Option v-for="item in oreList" :value="item.oreId" :key="item.index">{{ item.oreName }}</Option>
          </Select>
        </div>
        <div class="flexr0c select-box">
          <div class="label">申报状态</div>
          <Select v-model="state" style="width: 140px" @on-change="getTable(1)">
            <Option v-for="item in statusList" :value="item.value" :key="item.index">{{ item.name }}</Option>
          </Select>
        </div>
        <div class="flexr0c search-item">
          <div class="label">需方企业</div>
          <Input v-model="buyerName" icon="ios-search" placeholder="" style="width: 160px" @on-click="getTable(1)" @on-enter="getTable(1)" />
        </div>
        <div class="flexr0c search-item">
          <div class="label">预申报编号</div>
          <Input v-model="contractNo" icon="ios-search" placeholder="" style="width: 160px" @on-click="getTable(1)" @on-enter="getTable(1)" />
        </div>
      </div>
      <div class="no-data-box flexccc">
        <img src="../../assets/imgs/home/no-data.png" alt="" />
        <div class="no-data-txt">暂无数据</div>
      </div>
    </div>
  </div>
</template>

<script>
import vueViewer from "../bigImg/Viewer.vue";
export default {
  name: "preDeclare",
  components: {
    vueViewer,
  },
  data () {
    return {
      date: '',
      isShowBig: false,
      bigUrl: [],
      type: 1,
      oreId: "",
      oreList: [],
      state: "",
      fileCommonUrl: "",
      lastMoney: "",
      lastWeight: "",
      statusList: [
        {
          name: "全部",
          value: "",
        },
        {
          name: "未审核",
          value: 0,
        },
        {
          name: "已审核",
          value: 1,
        },
        {
          name: "审核不通过",
          value: 2,
        },
        {
          name: "执行中",
          value: 3,
        },
        {
          name: "已结束",
          value: 4,
        },
        // {
        //     name: "删除",
        //     value: 5
        // },
      ],
      buyerName: "",
      contractNo: "",
      loading1: false,
      loading2: false,
      loading3: false,
      total: 0,
      pageSize: 10,
      tips1: false,
      tips2: false,
      tips3: false,
      end: false,
      failure: false,
      tableHead: [
        {
          title: "预申报编号",
          slot: "contractNo",
          width: 190,
          resizable: true,
        },
        {
          title: "交易矿种",
          key: "oreName",
          width: 170,
          resizable: true,
        },
        {
          title: "申报量(吨)",
          key: "contNum",
          width: 100,
          resizable: true,
        },
        {
          title: "预计税费(元)",
          key: "taxSum",
          width: 120,
          resizable: true,
        },
        {
          title: "执行日期",
          slot: "setStartDateStr",
          width: 200,
          resizable: true,
        },
        {
          title: "调运企业",
          slot: "enterpriseName",
          width: 220,
          resizable: true,
        },
        {
          title: "需方企业",
          slot: "buyerName",
          width: 220,
          resizable: true,
        },
        {
          title: "申报状态",
          slot: "state",
          width: 120,
          resizable: true,
          fixed: "right",
        },
        {
          title: "操作",
          slot: "action",
          width: 180,
          resizable: true,
          fixed: "right",
        },
      ],
      tableData: [],
      tableHead2: [
        {
          title: "过站码",
          key: "checkCode",
          width: 100,
          resizable: true,
        },
        {
          title: "调运日期",
          key: "createTime",
          width: 190,
          resizable: true,
        },
        {
          title: "调运量(吨)",
          key: "totalWeight",
          width: 130,
          resizable: true,
        },
        {
          title: "调运车次",
          key: "truckCount",
          width: 130,
          resizable: true,
        },
        {
          title: "未过站",
          slot: "notPassCount",
          width: 130,
          resizable: true,
        },
        {
          title: "剩余有效时间",
          key: "remainTime",
          //   width: 150,
          resizable: true,
        },
        {
          title: "调运详情",
          slot: "detail",
          width: 100,
          resizable: true,
          fixed: "right",
        },
      ],
      tableData2: [],
      tableHead3: [
        {
          title: "车牌号码",
          key: "plateNum",
          width: 120,
          resizable: true,
        },
        {
          title: "车辆载重(吨)",
          key: "notPassStationTruckWeight",
          width: 130,
          resizable: true,
        },
        {
          title: "司机姓名",
          key: "driverName",
          width: 170,
          resizable: true,
        },
        {
          title: "司机联系方式",
          key: "driverPhone",
          width: 170,
          resizable: true,
        },
        {
          title: "过站状态",
          slot: "state",
          width: 110,
          resizable: true,
        },
        {
          title: "过站时间",
          key: "passTime",
          width: 200,
          resizable: true,
        },
        {
          title: "过站净重(吨)",
          key: "netWeight",
          width: 130,
          resizable: true,
        },
        {
          title: "过站税费(元)",
          key: "payMoney",
          width: 130,
          resizable: true,
        },
        {
          title: "计量站",
          key: "stationName",
          width: 150,
          resizable: true,
        },
      ],
      tableData3: [],
      session: {}, //登录信息
      pageIndex: 1,
      lookInfo: {
        moneyWeightMap: {},
      },
      dispatchDetail: {},
      imgArr: [],
      longDetailArr: [], //预申报查看详情部分的完整tableData
      showMore: false, //预申报查看详情部分的查看更多的显示隐藏
      preDeclare: -1, //预申报（1）/非预申报（0）判断
    };
  },
  created () {
    this.date = this.dateFormat('YYYY-mm-dd', new Date())
    this.session = JSON.parse(localStorage["session"]);
    this.fileCommonUrl = localStorage.getItem("fileCommonUrl");
    this.preDeclare = this.session.isNeedContract;
    if (this.session) {
      this.getTable(1);
      this.getOreList();
    }
  },
  methods: {
    //处理时间的函数（分钟数转换）
    timeStampDiao (StatusMinute) {
      var day = parseInt(StatusMinute / 60 / 24);
      var hour = parseInt((StatusMinute / 60) % 24);
      var min = parseInt(StatusMinute % 60);
      StatusMinute = "";
      if (day > 0) {
        StatusMinute = day + "天";
      }
      if (hour > 0) {
        StatusMinute += hour + "小时";
      }
      if (min > 0) {
        StatusMinute += parseFloat(min) + "分钟";
      }
      //三元运算符 传入的分钟数不够一分钟 默认为0分钟，else return 运算后的StatusMinute
      return StatusMinute == "" ? "0分钟" : StatusMinute;
    },
    timeStampYu (StatusMinute) {
      var day = parseInt(StatusMinute / 60 / 24);
      var hour = parseInt((StatusMinute / 60) % 24);
      var min = parseInt(StatusMinute % 60);
      StatusMinute = "";
      if (day > 0) {
        StatusMinute = day + "天";
      } else if (hour > 0) {
        StatusMinute += hour + "小时";
      } else if (min > 0) {
        StatusMinute += parseFloat(min) + "分钟";
      }
      //三元运算符 传入的分钟数不够一分钟 默认为0分钟，else return 运算后的StatusMinute
      return StatusMinute == "" ? "0分钟" : StatusMinute;
    },
    dateFormat (fmt, date) {
      let ret;
      const opt = {
        "Y+": date.getFullYear().toString(), // 年
        "m+": (date.getMonth() + 1).toString(), // 月
        "d+": date.getDate().toString(), // 日
        "H+": date.getHours().toString(), // 时
        "M+": date.getMinutes().toString(), // 分
        "S+": date.getSeconds().toString(), // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
      };
      for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
          fmt = fmt.replace(ret[1], ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, "0"));
        }
      }
      return fmt;
    },
    showMore1 () {
      this.tips1 = true;
    },
    showMore2 () {
      this.tips3 = true;
      this.tips1 = false;
    },
    hideMore () {
      this.tips3 = false;
      this.tips1 = false;
    },
    leaveIcon () {
      let timeout = setTimeout(() => {
        if (!this.tips3) {
          this.hideMore();
          clearTimeout(this.leaveIcon);
        }
      }, 500);
    },
    gobig: function (url) {
      if (this.bigUrl.length != 0) {
        this.bigUrl = [];
      }
      this.isShowBig = true;
      this.bigUrl.push(url);
    },
    manage () {
      this.type = 1;
    },
    // 获取矿种
    getOreList () {
      this.$http
        .post({
          sessionId: this.session.sessionId,
          userId: this.session.userId,
          enterpriseId: this.session.enterpriseId,
          modeCode: "8Nj3MDYFYm6AMtHz8dYeDsMk7bEAC8Cg",
        })
        .then((res) => {
          if (res.code == 1) {
            this.oreList = res.data;
          } else {
            this.$Message["error"]({
              background: true,
              content: res.msg,
            });
          }
        });
    },
    lookDetail: function () {
      this.imgArr = [];     //清空图片列表
      this.type = 1;
    },
    changePage (page) {
      this.getTable(page);
    },
    hover (index) {
      this.hoverIndex = index;
    },
    toDetail (row, index) {
      this.type = 2;
      this.getDetail(row.id, index);
    },
    lookMore () {
      this.tableData2 = this.longDetailArr;
      this.showMore = false;
    },
    addPre () {
      if (window.sessionStorage.getItem("from")) {
        window.sessionStorage.removeItem("from");
      }
      let goData = {
        title: "新增预申报",
      };
      window.sessionStorage.setItem("goData", JSON.stringify(goData));
      this.$router.push({
        name: "grantlist",
        params: {
          title: "新增预申报",
        },
      });
    },
    exportTable () {
      const session = JSON.parse(localStorage["session"]);
      let data = {
        modeCode: "oVYcwU7uhtRonjZlX4bE434Ytuhk2JOP",
        sessionId: session.sessionId,
        enterpriseId: session.enterpriseId,
        fileName: "预申报矿产调运", //导出文件名称
        suffix: "xlsx", //导出文件类型
      };
      this.$http.exportMethod(data).then((res) => {
        if (res.code == 1) {
          console.log("导出成功", res);
        }
      });
    },
    getDetail (id, index) {
      this.$http
        .post({
          sessionId: this.session.sessionId,
          modeCode: "aE8SXbHd8PuiUzB1XnlqgWEg2ty6mYAW",
          id: id,
        })
        .then((res) => {
          if (res.code == 1) {
            let info = res.data.contract;
            info.lastTime = this.timeStampYu(info.minutesLeft);
            if (info.minutesLeft <= 0) {
              info.minutesLeft = 0;
              this.end = true;
            } else {
              this.end = false;
            }
            res.data.billList.forEach((item) => {
              item.remainTime = this.timeStampDiao(item.minutes);
            });
            this.longDetailArr = res.data.billList;
            if (this.longDetailArr.length > 5) {
              this.showMore = true;
            }
            this.tableData2 = res.data.billList.slice(0, 5);
            info.pictrues.forEach((item) => {
              this.imgArr.push(item.picPath);
            });
            this.lookInfo = info;
            this.lastMoney = (this.lookInfo.contNum - this.lookInfo.moneyWeightMap.SUM_NET_WEIGHT - this.lookInfo.moneyWeightMap.SUM_ESTIMATE_WEIGHT) * this.lookInfo.moneyWeightMap.TAX_PRICE;
            this.lastWeight = this.lookInfo.contNum - this.lookInfo.moneyWeightMap.SUM_NET_WEIGHT - this.lookInfo.moneyWeightMap.SUM_ESTIMATE_WEIGHT;
          } else {
            this.$Message["error"]({
              background: true,
              content: "获取信息失败，请重试",
            });
          }
        });
    },
    getDispatchDetail (id, index) {
      this.$http
        .post({
          sessionId: this.session.sessionId,
          modeCode: "T5Ij7VAQuPJa6OTK76lFgRCWhtnp4xBl",
          id: id,
        })
        .then((res) => {
          if (res.code == 1) {
            let info = this.tableData2[index];
            if (info.minutesLeft <= 0) {
              info.minutesLeft = 0;
              this.failure = true;
            } else {
              this.failure = false;
            }
            this.dispatchDetail = this.tableData2[index];
            res.data.forEach((item) => {
              if (item.state == 0) {
                item.state = "未过站";
                item.notPassStationTruckWeight = "";
                item.stationName = "";
              } else {
                item.state = "已过站";
              }
            });
            this.tableData3 = res.data;
            this.type = 4;
          } else {
            this.$Message["error"]({
              background: true,
              content: "获取信息失败，请重试",
            });
          }
        });
    },
    look (row) {
      this.msg = "查看";
      this.type = 3;
      this.getDetail(row.id);
    },
    edit (row, title) {
      let goData = {
        row: row,
        title: title,
      };
      this.$router.push({
        name: "grantlist",
        params: {
          row: row,
          title: title,
        },
      });
      window.sessionStorage.setItem("goData", JSON.stringify(goData));
    },
    dispatch (index) {
      if (window.sessionStorage.getItem("from")) {
        window.sessionStorage.removeItem("from");
      }
      window.localStorage.setItem("dispatchInfo", JSON.stringify(this.tableData[index]));
      this.$router.push({
        path: "/wayBill",
      });
    },
    del (id) {
      this.$http
        .post({
          sessionId: this.session.sessionId,
          modeCode: "FYiGwcFCc1jvZAyyg197GWxGax37B8aJ",
          id: id,
        })
        .then((res) => {
          if (res.code == 1) {
            this.$Message["success"]({
              background: true,
              content: "删除成功",
            });
            this.getTable(1);
          } else {
            this.$Message["error"]({
              background: true,
              content: "删除失败，请重试",
            });
          }
        });
    },

    getTable (index) {
      this.loading1 = true;
      let data = {
        sessionId: this.session.sessionId,
        // userId: this.session.userId,
        modeCode: "ifExaKOFO4QK9ZtjKFBl98gaOI7OvM4A",
        enterpriseId: this.session.enterpriseId,
        pageIndex: index,
        pageSize: this.pageSize,
        oreId: this.oreId,
        state: this.state,
        buyerName: this.buyerName,
        contractNo: this.contractNo,
      };
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          res.data.list.forEach((item) => {
            switch (item.state) {
              case 0:
                item.status = "审批中";
                break;
              case 1:
                item.status = "已审批";
                break;
              case 2:
                item.status = "已驳回";
                break;
              case 3:
                item.status = "执行中";
                break;
              case 4:
                item.status = "已结束";
                break;

              default:
                break;
            }
          });
          this.tableData = res.data.list;
          this.total = res.data.count;
        } else {
          this.$Message["error"]({
            background: true,
            content: res.msg,
          });
        }
        this.loading1 = false;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  .home {
    .top-box {
      background-image: linear-gradient(180deg, #ffffff 0%, #e8e9ea 100%);
      border-radius: 10px 10px 0 0;
      width: 100%;
      height: 40px;

      & > div {
        height: 100%;
        width: 928px;
        margin: 0 auto;
      }

      .title-label {
        width: 4px;
        height: 14px;
        background: #2c59c3;
      }

      .title {
        font-family: PingFangSC-Semibold;
        font-size: 16px;
        color: #2c59c3;
        letter-spacing: 0.4px;
        margin-left: 6px;
      }

      .addOre {
        background-image: linear-gradient(180deg, #b4ec51 0%, #429321 100%);
        border: 1px solid #4c9b25;
        border-radius: 6px;
        width: 110px;
        height: 30px;
        cursor: pointer;

        &:hover {
          background-image: linear-gradient(180deg, #c4ff5b 0%, #4aa824 100%);
        }

        img {
          width: 14px;
          height: 14px;
          margin-right: 5px;
        }

        .btn {
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #ffffff;
          letter-spacing: 0.35px;
        }
      }

      .export {
        width: 80px;
        height: 30px;
        line-height: 30px;
        background-image: linear-gradient(180deg, #91caff 0%, #0074d6 97%);
        border: 1px solid #006bc4;
        border-radius: 6px;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #ffffff;
        letter-spacing: 0.35px;
        text-align: center;
        margin-left: 14px;
        cursor: pointer;

        &:hover {
          background-image: linear-gradient(180deg, #cce7ff 0%, #027de6 97%);
        }
      }
    }

    .search-box {
      height: 74px;

      .label {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #616c84;
        letter-spacing: 0;
        margin-right: 10px;
      }

      .select-box,
      .search-item {
        margin-left: 25px;
      }

      /deep/.ivu-select-selected-value {
        height: 38px;
        line-height: 38px;
        text-align: left;
      }

      /deep/.ivu-select-selection,
      /deep/.ivu-input {
        height: 38px;
        // border: 1px solid #CCD1DD;
        box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.17);
        border-radius: 4px;
      }

      /deep/ .ivu-input-suffix i {
        line-height: 38px;
      }
    }

    .table-box {
      background: #ffffff;
      box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
      border-radius: 10px;
      border-radius: 10px;
      min-height: 534px;
      overflow: hidden;

      .table {
        width: 928px;
        margin: 18px 0 0 26px;

        /deep/.ivu-table-cell {
          padding-left: 12px;
          overflow: unset;
        }

        .rejected {
          color: #d0021b;
        }

        .order-id {
          cursor: pointer;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #4a90e2;
        }

        .ckeck-state {
          & > .iconfont {
            margin-right: 6px;
          }

          .checked {
            width: 15px;
            height: 15px;
            margin-right: 6px;
          }

          .rejected-icon {
            margin-left: 8px;
            width: 15px;
            height: 15px;
          }

          .omit {
            width: 100px;
            white-space: nowrap !important;
            text-overflow: ellipsis !important;

            p {
              font-family: PingFangSC-Regular;
              font-size: 12px;
              color: #000000;
              line-height: 24px;
              overflow: hidden !important;
              white-space: nowrap !important;
              text-overflow: ellipsis !important;
            }
          }

          .dialog-box {
            width: 100px;
            // height: 80px;
            border-radius: 4px;
            position: relative;
            background: #ffffff;
            box-shadow: 0 14px 30px 0 rgba(0, 0, 0, 0.14);
            left: 15px;
            padding: 10px;
            box-sizing: border-box;

            &::before {
              content: "";
              width: 0;
              height: 0;
              border: 8px solid;
              position: absolute;
              left: -16px;
              top: 46%;
              border-color: transparent #fff transparent transparent;
            }

            p {
              font-family: PingFangSC-Regular;
              font-size: 12px;
              color: #000000;
              line-height: 24px;
              // overflow: hidden;
              // -webkit-box-orient: vertical;
              // text-overflow: ellipsis;
              // -webkit-line-clamp: 2;
            }
          }
        }
        .comName {
          width: 190px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
        .onSell {
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #27ae60;
          letter-spacing: 0;
          margin-left: 5px;
        }

        .stopSell {
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #d0021b;
          letter-spacing: 0;
          margin-left: 5px;
        }

        .icon-box {
          position: relative;

          & > div {
            position: relative;

            // &:hover {
            //     color: #4a90e2;
            // }
          }

          .iconfont {
            cursor: pointer;

            &:last-child {
              margin-right: 0;
            }
          }

          .tips {
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #4a4a4a;
            letter-spacing: 0;
            margin: 0 15px 0 5px;
            cursor: pointer;
          }

          .dispatch {
            color: #5cae50;
          }

          .disable {
            color: #9b9b9b;
          }

          .dialog-box {
            width: 110px;
            height: 46px;
            border-radius: 4px;
            position: relative;
            background: #ffffff;
            box-shadow: 0 14px 30px 0 rgba(0, 0, 0, 0.14);
            left: 15px;
            padding: 10px;
            box-sizing: border-box;

            &::before {
              content: "";
              width: 0;
              height: 0;
              border: 8px solid;
              position: absolute;
              left: -16px;
              top: 18px;
              border-color: transparent #fff transparent transparent;
            }

            p {
              font-family: PingFangSC-Regular;
              font-size: 12px;
              color: #000000;
              line-height: 24px;
            }
          }
        }
      }
    }
  }

  .detail {
    .top {
      background: #f9fafc;

      .addr {
        width: 14px;
        height: 18px;
        margin: 15px;
        margin-right: 8px;
      }

      .title {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #adb2bc;
        letter-spacing: 0.26px;
        cursor: pointer;
      }

      .arrow {
        width: 7px;
        height: 14px;
        margin: 0 10px;
      }
    }

    .content {
      width: 100%;
      // height: 600px;
      background-color: #fff;
      box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
      border-radius: 10px;
      overflow: auto;

      .red {
        color: #d0021b !important;
      }

      .top-card {
        width: 928px;
        height: 110px;
        border: 1px solid #ebedf3;
        margin: 20px 26px;

        .card-left {
          border-right: 1px solid #ebedf3;
          width: 257px;
          padding: 14px 24px;
          box-sizing: border-box;

          .label {
            font-family: PingFangSC-Regular;
            font-size: 16px;
            color: #8b93a7;
            letter-spacing: 0.4px;
            margin-bottom: 8px;
          }

          .value {
            font-family: PingFangSC-Semibold;
            font-size: 18px;
            color: #25265e;
          }
        }

        .card-right {
          width: 100%;
          padding: 14px 24px;
          box-sizing: border-box;

          .label {
            width: 80px;
            margin-right: 12px;
            font-family: PingFangSC-Semibold;
            font-size: 16px;
            color: #8b93a7;
            // letter-spacing: 0;
            text-align: right;
          }

          .label2 {
            margin-right: 6px;
            width: auto;
          }

          .two-word {
            .span1 {
              width: 64px;
              display: inline-block;
              text-align: justify;
              text-align-last: justify;
            }
          }

          .value {
            font-family: PingFangSC-Semibold;
            font-size: 16px;
            color: #4a4a4a;
            letter-spacing: 0;
          }
        }
      }

      .content2 {
        width: 928px;
        margin: 0 26px;
        margin-bottom: 20px;

        .title-box {
          width: 928px;
          height: 40px;
          background-color: rgba(224, 229, 240, 0.3);

          .title {
            font-family: PingFangSC-Semibold;
            font-size: 16px;
            color: #8b93a7;
            flex: 1;
            text-align: center;
          }
        }

        .item-box {
          width: 928px;
          height: 80px;

          .num {
            font-family: Impact;
            font-size: 24px;
            flex: 1;
            margin: 25px 0;
            color: #2c59c3;
            text-align: center;
          }
        }

        .look-box {
          cursor: pointer;

          .tips {
            margin-left: 5px;
          }
        }

        .look-more {
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #2c59c3;
          letter-spacing: 0.35px;
          text-align: right;
          margin: 13px 0;
          cursor: pointer;

          .txt {
            margin-right: 6px;
          }
        }
      }
    }
  }

  .dispatch-detail {
    width: 100%;
    background: #ffffff;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    overflow: auto;

    .top {
      background: #fff;

      .addr {
        width: 14px;
        height: 18px;
        margin: 15px;
        margin-right: 8px;
      }

      .title {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #adb2bc;
        letter-spacing: 0.26px;
        cursor: pointer;
      }

      .arrow {
        width: 7px;
        height: 14px;
        margin: 0 10px;
      }
    }

    .top-card {
      width: 928px;
      height: 158px;
      border: 1px solid #ebedf3;
      margin: 15px 26px;

      .card-left {
        width: 257px;
        height: 100%;
        border-right: 1px solid #ebedf3;
        padding: 14px 24px;
        box-sizing: border-box;

        .label {
          font-family: PingFangSC-Regular;
          font-size: 16px;
          color: #8b93a7;
          letter-spacing: 0.4px;
        }

        .value {
          font-family: Impact;
          font-size: 36px;
          color: #d0021b;
          letter-spacing: 0.77px;
        }

        .time {
          font-family: PingFangSC-Semibold;
          font-size: 16px;
          color: #8b93a7;
          letter-spacing: 0;

          .red {
            color: #d0021b;
          }
        }
      }

      .card-right {
        padding: 40px 24px;
        box-sizing: border-box;
        position: relative;

        & > div {
          width: 310px;

          .label {
            margin-bottom: 6px;

            & > div:first-child {
              font-family: PingFangSC-Semibold;
              font-size: 16px;
              color: #8b93a7;
              letter-spacing: 0;
              width: 80px;
              text-align: right;
            }

            & > div:last-child {
              font-family: PingFangSC-Semibold;
              font-size: 16px;
              color: #4a4a4a;
              letter-spacing: 0;
            }

            .label-txt {
              width: 64px;
              display: inline-block;
              text-align: justify;
              text-align-last: justify;
            }
          }
        }

        img {
          position: absolute;
          top: 15px;
          right: 15px;
        }
      }
    }

    .table {
      width: 928px;
      margin: 18px 0 20px 26px;

      .red {
        color: #d0021b;
      }
      .green {
        color: #5cae50;
      }

      .look-box {
        cursor: pointer;

        .tips {
          margin-left: 6px;
        }
      }
    }
  }

  .lookBox {
    background-color: white;
    border-radius: 10px;

    .top {
      background-color: white;
      border-radius: 10px;

      .addr {
        width: 14px;
        height: 18px;
        margin: 15px;
        margin-right: 8px;
      }

      .title {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #adb2bc;
        letter-spacing: 0.26px;
        cursor: pointer;
      }

      .arrow {
        width: 7px;
        height: 14px;
        margin: 0 10px;
      }
    }

    .lookBox_content {
      width: 90%;
      margin: 0 auto;

      .flex_between {
        display: flex;
        width: 100%;
        font-size: 14px;

        div {
          text-align: left;
          width: 45%;

          .flex_between_son1 {
            width: 100%;
            height: 48px;
            line-height: 48px;
            font-family: PingFangSC-Semibold;
            font-size: 14px;
            color: #9097a9;
            letter-spacing: 0.26px;
          }

          .flex_between_son2 {
            width: 100%;
            height: 48px;
            line-height: 48px;
            background: #f5f7fa;
            border-radius: 8px;
            box-sizing: border-box;
            padding-left: 24px;
            font-family: PingFangSC-Semibold;
            font-size: 14px;
            color: #4a4a4a;
            letter-spacing: 0.26px;
            word-break: break-all;
          }
        }
      }

      .lookBox_imgBox {
        text-align: left;

        .lookBox_imgBox_title {
          font-family: PingFangSC-Semibold;
          font-size: 14px;
          color: #9097a9;
          letter-spacing: 0.26px;
          height: 48px;
          line-height: 48px;
        }

        .imgArr {
          width: 100%;
          display: flex;
          flex-wrap: wrap;

          .imgArr_son {
            width: 221px;
            height: 294px;
            text-align: center;
            display: flex;
            align-items: center;

            img {
              width: 210px;
              height: 280px;
            }
          }
        }
      }
    }
  }

  .no-data {
    .top-box {
      background-image: linear-gradient(180deg, #ffffff 0%, #e8e9ea 100%);
      border-radius: 10px 10px 0 0;
      width: 100%;
      height: 40px;

      & > div {
        height: 100%;
        width: 928px;
        margin: 0 auto;
      }

      .title-label {
        width: 4px;
        height: 14px;
        background: #2c59c3;
      }

      .title {
        font-family: PingFangSC-Semibold;
        font-size: 16px;
        color: #2c59c3;
        letter-spacing: 0.4px;
        margin-left: 6px;
      }

      .addOre {
        background-image: linear-gradient(180deg, #b4ec51 0%, #429321 100%);
        border: 1px solid #4c9b25;
        border-radius: 6px;
        width: 110px;
        height: 30px;
        cursor: pointer;

        &:hover {
          background-image: linear-gradient(180deg, #c4ff5b 0%, #4aa824 100%);
        }

        img {
          width: 14px;
          height: 14px;
          margin-right: 5px;
        }

        .btn {
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #ffffff;
          letter-spacing: 0.35px;
        }
      }

      .export {
        width: 80px;
        height: 30px;
        line-height: 30px;
        background-image: linear-gradient(180deg, #91caff 0%, #0074d6 97%);
        border: 1px solid #006bc4;
        border-radius: 6px;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #ffffff;
        letter-spacing: 0.35px;
        text-align: center;
        margin-left: 14px;
        cursor: pointer;

        &:hover {
          background-image: linear-gradient(180deg, #cce7ff 0%, #027de6 97%);
        }
      }
    }

    .search-box {
      height: 74px;

      .label {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #616c84;
        letter-spacing: 0;
        margin-right: 10px;
      }

      .select-box,
      .search-item {
        margin-left: 25px;
      }

      /deep/.ivu-select-selected-value {
        height: 38px;
        line-height: 38px;
        text-align: left;
      }

      /deep/.ivu-select-selection,
      /deep/.ivu-input {
        height: 38px;
        // border: 1px solid #CCD1DD;
        box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.17);
        border-radius: 4px;
      }

      /deep/ .ivu-input-suffix i {
        line-height: 38px;
      }
    }

    .no-data-box {
      background-color: #fff;
      height: 662px;
      width: 980px;
      box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
      border-radius: 10px;

      img {
        width: 210px;
        height: 140px;
      }

      .no-data-txt {
        margin-top: 20px;
        font-family: PingFangSC-Medium;
        font-size: 12px;
        color: #9999a8;
        letter-spacing: 0.22px;
      }
    }
  }
}

.flex_between > div:nth-child(2) {
  margin-left: 10%;
}

/deep/ .ivu-select-single .ivu-select-selection .ivu-select-placeholder {
  line-height: 36px;
  text-align: left;
}

/deep/ .ivu-select-input {
  height: 36px;
}

/deep/.ivu-input-icon {
  line-height: 40px;
}

/deep/.ivu-table-stripe .ivu-table-body tr:nth-child(2n) td,
/deep/.ivu-table-stripe .ivu-table-fixed-body tr:nth-child(2n) td {
  // background-color: rgba(236, 241, 247, 0.4);
  background-color: #f7f9fc;
}

/deep/.ivu-table-stripe .ivu-table-fixed-body tr:nth-child(2n) td::before {
  content: "";
  opacity: 1;
}

/deep/.ivu-table-stripe .ivu-table-body tr.ivu-table-row-hover td,
/deep/.ivu-table-stripe .ivu-table-fixed-body tr.ivu-table-row-hover td {
  // background: rgba(255, 255, 235, 0.15) !important;
  background: #fffff9 !important;
}

/deep/.ivu-table-row-hover {
  background: #fffff9 !important;
}
</style>
